import { Toasts } from './toastsTypes';

const defaultState: Toasts = {
  hasShownMultipackMessageFor: [],
};

export default defaultState;
